/**
 * Line-art icons (24×24, stroke-based) used across Practices / Products / Industries
 * cards. Kept as inline React SVG so we control colour and never load third-party
 * brand marks anywhere outside the Technology page.
 */

const S = ({ children, size = 26 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        {children}
    </svg>
);

// ---------- PRACTICES ----------
export const IconCX = () => (
    <S>
        <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
        <path d="M8 10h8M8 13.5h5" />
    </S>
);
export const IconData = () => (
    <S>
        <ellipse cx="12" cy="5" rx="8" ry="3" />
        <path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
    </S>
);
export const IconAI = () => (
    <S>
        <path d="M12 3v3M12 18v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M3 12h3M18 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
        <circle cx="12" cy="12" r="4" />
    </S>
);
export const IconShieldLock = () => (
    <S>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <rect x="9" y="10" width="6" height="6" rx="1" />
        <path d="M10 10V8a2 2 0 0 1 4 0v2" />
    </S>
);
export const IconCloud = () => (
    <S>
        <path d="M6 18a4 4 0 0 1 0-8 6 6 0 0 1 11.5 1.5A3.5 3.5 0 0 1 17 18z" />
        <path d="M10 14l2 2 3-3" />
    </S>
);
export const IconWorkflow = () => (
    <S>
        <rect x="3" y="3" width="6" height="6" rx="1" />
        <rect x="15" y="15" width="6" height="6" rx="1" />
        <rect x="15" y="3" width="6" height="6" rx="1" />
        <path d="M9 6h6M18 9v6" />
    </S>
);

// ---------- PRODUCTS ----------
export const IconEngine = () => (
    <S>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
    </S>
);
export const IconEngage = () => (
    <S>
        <circle cx="12" cy="12" r="2.4" />
        <circle cx="5" cy="6" r="1.6" />
        <circle cx="19" cy="6" r="1.6" />
        <circle cx="5" cy="18" r="1.6" />
        <circle cx="19" cy="18" r="1.6" />
        <path d="M10.2 10.6L6.4 7.4M13.8 10.6l3.8-3.2M10.2 13.4l-3.8 3.2M13.8 13.4l3.8 3.2" />
    </S>
);
export const IconXchange = () => (
    <S>
        <path d="M3 8h14l-3-3M21 16H7l3 3" />
    </S>
);
export const IconCXSuite = () => (
    <S>
        <path d="M4 4h16v10H4z" />
        <path d="M4 18h9M4 21h6" />
        <path d="M8 8h4M8 11h6" />
    </S>
);
export const IconGCC = () => (
    <S>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z" />
    </S>
);
export const IconFoundry = () => (
    <S>
        <path d="M4 20h16M6 20V10l6-6 6 6v10M9 20v-5h6v5" />
    </S>
);

// ---------- INDUSTRIES ----------
export const IconPlane = () => (
    <S>
        <path d="M21 16l-9-4-9 4v-2l9-6V4a2 2 0 1 1 4 0v4l5 4z" />
    </S>
);
export const IconTrain = () => (
    <S>
        <rect x="5" y="3" width="14" height="14" rx="3" />
        <path d="M5 10h14M9 21l-2-3M15 21l2-3" />
        <circle cx="9" cy="13.5" r="1" />
        <circle cx="15" cy="13.5" r="1" />
    </S>
);
export const IconHotel = () => (
    <S>
        <path d="M3 21V6l9-4 9 4v15" />
        <path d="M9 10h6M9 14h6M11 21v-4h2v4" />
    </S>
);
export const IconTruck = () => (
    <S>
        <rect x="1" y="6" width="15" height="10" rx="1" />
        <path d="M16 8h4l3 4v4h-7" />
        <circle cx="6" cy="18" r="2" />
        <circle cx="19" cy="18" r="2" />
    </S>
);
export const IconAntenna = () => (
    <S>
        <path d="M12 4v14" />
        <path d="M9 9c0-1.5 1.4-3 3-3s3 1.5 3 3" />
        <path d="M6 9c0-3 2.7-6 6-6s6 3 6 6" />
        <path d="M9 22h6" />
        <path d="M10.5 22l1.5-4 1.5 4" />
    </S>
);
export const IconHeart = () => (
    <S>
        <path d="M12 21s-8-5-8-11a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6-8 11-8 11z" />
    </S>
);
export const IconBank = () => (
    <S>
        <path d="M3 10L12 4l9 6" />
        <path d="M5 10v9M9 10v9M15 10v9M19 10v9M3 21h18" />
    </S>
);
export const IconAppliance = () => (
    <S>
        <rect x="4" y="3" width="16" height="18" rx="2" />
        <path d="M4 9h16" />
        <circle cx="12" cy="15" r="3" />
    </S>
);

// ---------- USE CASE FUNCTION BUCKETS ----------
export const IconListen = () => (
    <S>
        <path d="M4 10v4M8 8v8M12 5v14M16 8v8M20 10v4" />
    </S>
);
export const IconSupport = () => (
    <S>
        <path d="M4 12a8 8 0 0 1 16 0v4a3 3 0 0 1-3 3h-1v-6h4" />
        <path d="M4 12v4a3 3 0 0 0 3 3h1v-6H4" />
    </S>
);
export const IconMegaphone = () => (
    <S>
        <path d="M3 11v2a2 2 0 0 0 2 2h1l4 4V5L6 9H5a2 2 0 0 0-2 2z" />
        <path d="M14 8c2 1 2 7 0 8" />
        <path d="M18 5c4 3 4 11 0 14" />
    </S>
);
export const IconOperate = () => (
    <S>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </S>
);

// Map ids → icon
export const PRACTICE_ICONS = {
    "customer-experience": <IconCX />,
    "data-martech": <IconData />,
    "ai-engineering": <IconAI />,
    cybersecurity: <IconShieldLock />,
    salesforce: <IconCloud />,
    servicenow: <IconWorkflow />,
};

export const PRODUCT_ICONS = {
    "kyro-cx": <IconCXSuite />,
    "kyro-engage": <IconEngage />,
    "kyro-engine": <IconEngine />,
    "kyro-xchange": <IconXchange />,
    "kyro-shield": <IconShieldLock />,
    "kyro-gcc": <IconGCC />,
    "kyro-foundry": <IconFoundry />,
};

export const INDUSTRY_ICONS = {
    travel: <IconPlane />,
    transport: <IconTrain />,
    hospitality: <IconHotel />,
    logistics: <IconTruck />,
    telecom: <IconAntenna />,
    healthcare: <IconHeart />,
    bfsi: <IconBank />,
    "consumer-durables": <IconAppliance />,
};

export const FUNC_ICONS = {
    listen: <IconListen />,
    support: <IconSupport />,
    reach: <IconMegaphone />,
    operate: <IconOperate />,
};

// ---------- SUB-ITEM ICONS ----------
// Additional glyphs for sub-item cards on detail pages.
export const IconPerson = () => (
    <S>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" />
    </S>
);
export const IconGraph = () => (
    <S>
        <path d="M4 20V10M10 20V4M16 20V13M22 20V7" />
    </S>
);
export const IconSpark = () => (
    <S>
        <path d="M12 2v6M12 16v6M2 12h6M16 12h6M4.9 4.9l4.2 4.2M14.9 14.9l4.2 4.2M4.9 19.1l4.2-4.2M14.9 9.1l4.2-4.2" />
    </S>
);
export const IconBook = () => (
    <S>
        <path d="M4 4h14a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4z" />
        <path d="M4 4v16" />
    </S>
);
export const IconLink = () => (
    <S>
        <path d="M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
        <path d="M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
    </S>
);
export const IconClipboard = () => (
    <S>
        <rect x="8" y="3" width="8" height="4" rx="1" />
        <path d="M8 5H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <path d="M9 12h6M9 16h4" />
    </S>
);
export const IconLoop = () => (
    <S>
        <path d="M4 12a8 8 0 0 1 14-5" />
        <path d="M20 12a8 8 0 0 1-14 5" />
        <path d="M14 3l4 4-4 4M10 21l-4-4 4-4" />
    </S>
);
export const IconRocket = () => (
    <S>
        <path d="M12 15c-3-1-5-3-6-6l7-7 7 7c-1 3-3 5-6 6z" />
        <path d="M9 12l-4 4M15 12l4 4M12 15v5" />
    </S>
);
export const IconTarget = () => (
    <S>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.5" />
    </S>
);
export const IconEye = () => (
    <S>
        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
        <circle cx="12" cy="12" r="3" />
    </S>
);

/**
 * Heuristic: pick a glyph for a sub-item card based on keywords in its name.
 * Returns a JSX icon. Falls back to a spark glyph.
 */
export function pickSubIcon(name = "") {
    const n = name.toLowerCase();
    // channels / voice / conversational
    if (/(voice|conversational|omnichannel|conversation|pulse|memory|channel)/.test(n))
        return <IconEngage />;
    // insight / analytics / graph
    if (/(insight|analytic|graph|decision|report|risk|churn|predict|score)/.test(n))
        return <IconGraph />;
    // person / assist / care / support
    if (/(assist|care|person|context|customer|talent|dealer)/.test(n))
        return <IconPerson />;
    // security / shield / compliance
    if (/(secur|shield|compliance|guardrail|resilience|continuity|recover)/.test(n))
        return <IconShieldLock />;
    // cloud
    if (/(cloud|scale|infra)/.test(n)) return <IconCloud />;
    // workflow / flow / action / orchestration
    if (/(workflow|flow|orchestrat|automation|action|bridge|control|command|tower)/.test(n))
        return <IconWorkflow />;
    // data / discovery / product
    if (/(data|discovery|product|catalog|autopilot|memory)/.test(n))
        return <IconData />;
    // exchange / integration / api / mcp
    if (/(exchange|integration|xchange|api|mcp|link)/.test(n)) return <IconLink />;
    // brain / ai / engineering / model
    if (/(ai|engineer|reason|model|foundation|coding)/.test(n)) return <IconAI />;
    // book / knowledge / faq
    if (/(knowledge|book|faq|content|seo|aeo)/.test(n)) return <IconBook />;
    // rocket / build / scale / transform / develop
    if (/(build|scale|transform|deploy|develop|foundry|discover|design)/.test(n))
        return <IconRocket />;
    // target / campaign / revenue / personal
    if (/(campaign|revenue|target|personal|market)/.test(n)) return <IconTarget />;
    // repeat / renewals / loop
    if (/(renewal|loop|warranty|amc|churn|repeat|last-mile|last mile)/.test(n))
        return <IconLoop />;
    // observability / eye / monitoring
    if (/(observ|monitor|track|eye|iot)/.test(n)) return <IconEye />;
    // clipboard / booking / servicing / reservation
    if (/(booking|reserv|servicing|schedul|intake|ticket|check|hospital)/.test(n))
        return <IconClipboard />;
    return <IconSpark />;
}
